<div class="custom-select-container">
	<mat-select #selectElement
				class="form-control filter-options custom-select"
				[ngClass]="extraClass"
				[value]="value"
				[matTooltip]="tooltipText"
				[disabled]="disabled"
				multiple
				(selectionChange)="onMatSelectionChange($event)"
				(openedChange)="onOpenedChange($event)">

		<!-- Custom trigger showing selected items -->
		<mat-select-trigger *ngIf="value?.length">
			{{ displayText }}
		</mat-select-trigger>

		<!-- Search input (sticky at top) -->
		<ng-container *ngIf="searchable">
			<div class="search-container position-sticky top-0">
				<div class="input-group">
					<input #searchInput
						   class="form-control"
						   type="text"
						   [ngModel]="searchValue"
						   (ngModelChange)="onSearchValueChange($event)"
						   (click)="$event.stopPropagation()"
						   (keydown)="$event.stopPropagation()"
						   placeholder="Search..."/>
					<button type="button"
							class="btn btn-outline-secondary bi bi-trash-fill btn-picker"
							[disabled]="!searchValue"
							(click)="clearSearch(); $event.stopPropagation()">
					</button>
				</div>
			</div>
		</ng-container>

		<!-- Options list with trackBy -->
		<mat-option *ngFor="let option of renderedOptions; trackBy: trackByOptionId"
					[value]="option.id">
			{{ option.name }}
		</mat-option>

		<!-- Hidden selected options (not in current page but needed in DOM for MatSelect) -->
		<mat-option *ngFor="let option of hiddenSelectedOptions; trackBy: trackByOptionId"
					[value]="option.id"
					class="hidden-option">
			{{ option.name }}
		</mat-option>

		<!-- Empty state -->
		<div *ngIf="renderedOptions?.length === 0"
			 class="empty-message w-100 text-center fw-bold mb-2 p-3">
			No result found
		</div>

		<!-- Pagination controls -->
		<div *ngIf="totalPages > 1"
			 class="pagination-controls d-flex align-items-center justify-content-center gap-1 p-2 border-top">
			<!-- First page -->
			<button type="button"
					class="btn btn-sm btn-outline-secondary"
					[disabled]="currentPage === 1"
					(click)="goToFirstPage($event)"
					title="First page">
				<i class="bi bi-chevron-double-left"></i>
			</button>

			<!-- Previous page -->
			<button type="button"
					class="btn btn-sm btn-outline-secondary"
					[disabled]="currentPage === 1"
					(click)="goToPreviousPage($event)"
					title="Previous page">
				<i class="bi bi-chevron-left"></i>
			</button>

			<!-- Page info -->
			<span class="pagination-info mx-2 text-nowrap">
				{{ currentPage }} / {{ totalPages }}
				<small class="text-muted">({{ totalFilteredCount }})</small>
			</span>

			<!-- Next page -->
			<button type="button"
					class="btn btn-sm btn-outline-secondary"
					[disabled]="currentPage === totalPages"
					(click)="goToNextPage($event)"
					title="Next page">
				<i class="bi bi-chevron-right"></i>
			</button>

			<!-- Last page -->
			<button type="button"
					class="btn btn-sm btn-outline-secondary"
					[disabled]="currentPage === totalPages"
					(click)="goToLastPage($event)"
					title="Last page">
				<i class="bi bi-chevron-double-right"></i>
			</button>
		</div>

	</mat-select>
</div>
